import yourFarmsTemplate from "./your_crews.html";
import en from "./en.translation.json";
import es from "./es.translation.json";
import { ACTIVE } from "../../../communication/constants";
import { crewCreateAnnouncementAddRecipientsState } from "../../../../crew.routes";

class YourCrewsController {
    /* @ngInject */
    constructor(AnnouncementService, $state, ToastService) {
        this.ACTIVE = ACTIVE;
        this.AnnouncementService = AnnouncementService;
        this.$state = $state;
        this.ToastService = ToastService;
    }
    createAnnouncement(sender, crew) {
        let ctrl = this;
        let announcement = {};
        announcement.sender = sender.sid;
        announcement.grower_organization = crew.grower_organization.sid;
        announcement.recipients = [];
        ctrl.AnnouncementService.create(announcement).then(
            function (res) {
                ctrl.$state.go(crewCreateAnnouncementAddRecipientsState, {
                    announcement_sid: res.sid,
                    crew_sid: crew.crew.sid,
                });
            },
            function () {
                ctrl.ToastService.create("yourCrews.TOAST_FAIL");
            },
        );
    }
}

export default {
    bindings: { crew: "<", managementMembership: "<", account: "<" },
    controller: YourCrewsController,
    template: yourFarmsTemplate,
    name: "yourCrews",
    translations: { en, es },
};
